import { Button, Typography } from "@mui/material";
import { css } from "aphrodite";
import styles from "./styles";


const CustomMainButton = ({
    value,
    style,
    isDisabled = false,
    variant = "contained",
    color = "primary",
    isSelected = false,
    isSelectable = false,
    disableElavation = true,
    selectedColor = "secondary",
    fixedSize = true,
    textColor = "white",
    textVariant = "h6",
    onClick = () => {},
}) => {
    return  (
        <Button
            disabled={isDisabled}
            variant={variant}
            color={isSelected ? selectedColor : color}
            disableElevation={disableElavation}
            className={css([
                styles.button,
                fixedSize && styles.fixedSize,
                style,
            ])}
            onClick={onClick}
            aria-pressed={isSelectable ? isSelected : undefined}
        >
            <Typography variant={textVariant} color={textColor}>
                {value}
            </Typography>
        </Button>
    );
};

export default CustomMainButton;
